import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, timeout, catchError, throwError } from "rxjs";
import { PwaService } from "../../pages/pwa-install-prompt/pwa.service";

@Injectable({ providedIn: "root" })
export class HttpTimeoutInterceptor implements HttpInterceptor {
	private pwaService = inject(PwaService);

	// Longer timeout for PWA mode (30s) due to service worker overhead
	private readonly PWA_TIMEOUT_MS = 30000;
	private readonly DEFAULT_TIMEOUT_MS = 15000;

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Skip timeout for S3 upload requests - FileService manages its own timeout
		if (req.method === "PUT" && req.url.includes("amazonaws.com")) {
			return next.handle(req);
		}

		const timeoutDuration = this.pwaService.isInPwaMode()
			? this.PWA_TIMEOUT_MS
			: this.DEFAULT_TIMEOUT_MS;

		const startTime = Date.now();

		return next.handle(req).pipe(
			timeout(timeoutDuration),
			catchError((error) => {
				if (error.name === "TimeoutError") {
					const elapsed = Date.now() - startTime;

					console.error("[HttpTimeout] Request timed out", {
						url: req.url,
						method: req.method,
						timeout: timeoutDuration,
						elapsed,
						isPwaMode: this.pwaService.isInPwaMode(),
					});

					return throwError(() => ({
						...error,
						message: `Request timeout after ${timeoutDuration}ms`,
						isTimeout: true,
						url: req.url,
						elapsed,
					}));
				}
				return throwError(() => error);
			})
		);
	}
}
